import './transferBatchSection.scss'
import * as React from 'react'
import { TransferProduct } from '@getgreenline/homi-shared'
import { FormError } from '../../../../../../components/FormError'
import { observer, inject } from 'mobx-react'
import { TransferStore } from '../../TransferStore'
import { CurrentCompanyStore } from '../../../../../../stores/CurrentCompanyStore'
import { TransferBatchOptionTable } from './TransferBatchOptionTable'
import { AddedTransferBatchTable } from './AddedTransferBatchTable'

interface IProps {
  currentCompanyStore?: CurrentCompanyStore
  transferProduct: TransferProduct
  transferStore: TransferStore
  canEditTransfers: boolean
  isEditable: boolean
}

interface State {
  errorMessage: string
}

@inject('currentCompanyStore')
@observer
export class TransferBatchSection extends React.Component<IProps, State> {
  companyId = this.props.currentCompanyStore!.company!.id

  constructor(props: IProps) {
    super(props)
    this.state = {
      errorMessage: '',
    }
  }

  render() {
    const { errorMessage } = this.state
    const { transferProduct, canEditTransfers, isEditable } = this.props

    return (
      <div className='batch-rows-container'>
        <div className='p-2'>
          <AddedTransferBatchTable
            transferProduct={transferProduct}
            canEditTransfers={canEditTransfers}
            isEditable={isEditable}
            transferStore={this.props.transferStore}
          />

          {canEditTransfers && isEditable && (
            <TransferBatchOptionTable
              transferProduct={transferProduct}
              transferStore={this.props.transferStore}
            />
          )}

          <FormError message={errorMessage} />
        </div>
      </div>
    )
  }
}
